

import $ from 'jquery';



export function onScrollElemento($elemento) {
    var timer = 0;
    var jaAtivou = false;
    $(window).on("scroll", function () {
        window.clearInterval(timer);
        timer = window.setTimeout(function () {
            var posWindow = $(window).scrollTop();
            var alturaJanela = $(window).height();
            var posSecao = $elemento.offset().top;
            if (!jaAtivou) {
                var estaVisivel = posSecao > posWindow && posSecao < posWindow + alturaJanela;
                var p = $elemento.offset();
                if (estaVisivel) {
                    jaAtivou = true;
                    $elemento.addClass("ativo");
                } else {
                    $elemento.removeClass("ativo");
                }
            }
        }, 10);
    });
}


export function posicionar(secao) {
    window.setTimeout(function () {
        var $secao = $("." + secao);
        var pos = $secao.position();
        if (!pos) {
            console.warn(secao);
            return;
        }
        $("body,html").stop(true, true).animate({
            scrollTop: pos.top
        });
    }, 100);


}


export function executaEntreIntervaloMinimo(fn, tempoIntervaloMinimo) {
    var last = 0;
    return function () {
        var agora = Date.now();
        if (agora - last >= tempoIntervaloMinimo) {
            last = agora;
            fn();
        }
    };
};



// WEBPACK FOOTER //
// ./src/js/modules/util.js